"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wireSaxesHandlers = wireSaxesHandlers;
function wireSaxesHandlers(parser, handlers) {
    const useSourceHandler = handlers.some((handler) => handler.type === "source");
    let lastLocation = {
        line: 0,
        col: 0,
        position: 0,
    };
    let attributeLocations = {};
    let lastAttributeLocation = {
        line: 0,
        col: 0,
        position: 0,
    };
    const provideLocation = () => {
        const location = {
            line: lastLocation.line,
            col: lastLocation.col,
            start: lastLocation.position,
            end: parser.position,
        };
        lastLocation = {
            line: parser.line,
            col: parser.columnIndex,
            position: parser.position,
        };
        return location;
    };
    parser.on("opentag", (node) => {
        const loc = provideLocation();
        for (const handler of handlers) {
            if (handler.type === "generic") {
                handler.onopen(node, loc);
            }
            if (handler.type === "source") {
                handler.onopen(node, loc, attributeLocations);
            }
        }
    });
    parser.on("text", (text) => {
        for (const handler of handlers) {
            handler.ontext(text, provideLocation());
        }
    });
    parser.on("closetag", (node) => {
        for (const handler of handlers) {
            handler.onclose(node, provideLocation());
        }
    });
    if (useSourceHandler) {
        parser.on("opentagstart", () => {
            attributeLocations = {};
            lastAttributeLocation = {
                line: parser.line,
                col: parser.column,
                position: parser.position,
            };
        });
        parser.on("attribute", (attr) => {
            attributeLocations[attr.name] = {
                line: lastAttributeLocation.line,
                col: lastAttributeLocation.col,
                start: lastAttributeLocation.position,
                end: parser.position,
            };
            lastAttributeLocation = {
                line: parser.line,
                col: parser.column,
                position: parser.position + 1,
            };
        });
    }
}
//# sourceMappingURL=wire-saxes-handlers.js.map